import { render, staticRenderFns } from "./election-signup-component.vue?vue&type=template&id=24b1922f&scoped=true"
import script from "./election-signup-component.ts?vue&type=script&lang=ts&external"
export * from "./election-signup-component.ts?vue&type=script&lang=ts&external"
import style0 from "./election-signup-component.scss?vue&type=style&index=0&id=24b1922f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b1922f",
  null
  
)

export default component.exports